export default __webpack_public_path__ + "static/media/Mechno-Leg-00.c8babb2e.jpg";